export const cmpId = 'typed';
export const traitStringId = 'typed-strings';